"use strict";
exports.__esModule = true;
exports.Carousel = void 0;
var Carousel_1 = require("./Carousel");
var CarouselAutoPlayButton_1 = require("./CarouselAutoPlayButton");
var CarouselBulletList_1 = require("./CarouselBulletList");
var CarouselContent_1 = require("./CarouselContent");
var CarouselContext_1 = require("./CarouselContext");
var CarouselItem_1 = require("./CarouselItem");
var CarouselNextButton_1 = require("./CarouselNextButton");
var CarouselPrevButton_1 = require("./CarouselPrevButton");
var Carousel = Object.assign(Carousel_1.Carousel, {
    AutoPlayButton: CarouselAutoPlayButton_1.CarouselAutoPlayButton,
    BulletList: CarouselBulletList_1.CarouselBulletList,
    Content: CarouselContent_1.CarouselContent,
    Context: CarouselContext_1.CarouselContext,
    Item: CarouselItem_1.CarouselItem,
    NextButton: CarouselNextButton_1.CarouselNextButton,
    PrevButton: CarouselPrevButton_1.CarouselPrevButton
});
exports.Carousel = Carousel;
//# sourceMappingURL=index.js.map